import React, { useState, useContext } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import * as FaIcons from 'react-icons/fa';
import * as AiIcons from 'react-icons/ai';
import * as ImIcons from 'react-icons/im';
import { SidebarData } from './SidebarData';
import SubMenu from './SubMenu';
import { IconContext } from 'react-icons/lib';
import UserContext from '../context/UsrContext';

const Nav = styled.div`
  background: #096dd9;
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const NavIcon = styled(Link)`
  margin-left: 2rem;
  font-size: 2rem;
  height: 80px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

const NavIcon2 = styled.div`
  margin-right: 2rem;
  font-size: 2rem;
  height: 100%;
  display: flex;
  align-items: center;
`;

const SidebarNav = styled.nav`
  background: #096dd9;
  width: 250px;
  height: 100vh;
  display: flex;
  justify-content: center;
  position: fixed;
  top: 0;
  left: ${({ sidebar }) => (sidebar ? '0' : '-100%')};
  transition: 350ms;
  z-index: 10;
`;

const SidebarWrap = styled.div`
  width: 100%;
`;

const SidebarLink = styled(Link)`
  display: flex;
  color: #e1e9fc;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  list-style: none;
  height: 60px;
  text-decoration: none;
  font-size: 18px;

  &:hover {
    background: #0F5096 ;
    border-left: 4px solid #FFFFFF;
    cursor: pointer;
    color: #e1e9fc;
  }

  &:active {
    color: #e1e9fc;
  }
`;

const SidebarLabel = styled.span`
  margin-left: 16px;
`;

const Sidebar = () => {
  const [sidebar, setSidebar] = useState(false);

  const cxt = useContext(UserContext);

  const handleLogOut = () => {
    cxt.onLogOut();
};

  const showSidebar = () => setSidebar(!sidebar);

  return (
    <React.Fragment>
      <IconContext.Provider value={{ color: '#fff' }}>
        <Nav>
          <NavIcon to='#'>
            <FaIcons.FaBars onClick={showSidebar} />
          </NavIcon>
          <NavIcon2>
            <img style={{borderRadius:'5px', height: '40%'}} className="layout-logo" alt="logo" src="./assets/images/logo12.png" />
          </NavIcon2>
        </Nav>
        
        <SidebarNav sidebar={sidebar}>
          
          <SidebarWrap>
          <NavIcon to='#'>
              <AiIcons.AiOutlineClose onClick={showSidebar} />
            </NavIcon>
            {/* <NavIcon to='#'>
              <AiIcons.AiOutlineClose onClick={showSidebar} />
            </NavIcon> */}
            <SidebarWrap>
            {SidebarData.map((item, index) => {
              return <SubMenu item={item} key={index} />;
            })}
            {cxt.user && <SidebarLink to="/" onClick={handleLogOut}>
                <div>
                  <ImIcons.ImExit/>
                  <SidebarLabel>Salir</SidebarLabel>
                </div>
              </SidebarLink>}
            </SidebarWrap>
            
          </SidebarWrap>
        </SidebarNav>
      </IconContext.Provider>
    </React.Fragment>
  );
};

export default Sidebar;


// WEBPACK FOOTER //
// ./src/components/Sidebar.js